module.exports = __webpack_public_path__ + "img/poster-1.30696e7a.jpg";